<template>

    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-10">
                        <blockquote
                            :class="quoteFormat.value"
                            v-html="quote"
                            data-aos="fade-up"
                        >
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'quote',
    components: {
        // AssetLoader
    },
    props: {
        quote: {
            type: String,
            required: true,
        },
        quoteFormat:{
            type: Object,
            required: true,
        }
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
